import { Textarea } from "@ember/component";
import DEditor from "discourse/components/d-editor";
import FormFieldBase from "./base";
import ValidationTip from "./validation-tip";
import FormFieldWireFrame from "./wire-frame";

export default class FormFieldEditor extends FormFieldBase {
  get useRichEditor() {
    return !this.args.disableRichEditor;
  }

  get textAreaValidation() {
    // use the standard placement in the controls wireframe only if we're not using the rich editor
    return this.useRichEditor ? null : this.args.validation;
  }

  <template>
    <FormFieldWireFrame
      @fieldName={{this.fieldName}}
      @title={{this.title}}
      @description={{this.description}}
      @required={{@required}}
    >
      {{#if this.useRichEditor}}
        <DEditor
          class="circles-form-{{@name}}"
          ...attributes
          name={{this.fieldName}}
          @autofocus={{@autofocus}}
          @placeholder={{this.placeholderI18n}}
          @value={{@value}}
        >
          <ValidationTip
            @validation={{@validation}}
            @value={{@value}}
            @maxLength={{@maxLength}}
          />
        </DEditor>
      {{else}}
        <Textarea
          class="circles-form-{{@name}}"
          ...attributes
          autofocus={{@autofocus}}
          name={{this.fieldName}}
          placeholder={{this.placeholder}}
          @value={{@value}}
        />
        <ValidationTip
          @validation={{@validation}}
          @value={{@value}}
          @maxLength={{@maxLength}}
        />
      {{/if}}
      {{yield}}
    </FormFieldWireFrame>
  </template>
}
